import { create, get, remove } from './common';

export default {
    uploadDocument: (params, token) => create(`/v1/Auction/UploadDocument`, params, token, true),
    getDocuments: (params, token) => get(`/v1/Auction/GetDocuments`, token),
    requestDocumentDownload: async (params, token) => get(`/v1/Document/ExternalRequestDownload?ID=${params.id}`, token),
    downloadDocument: async (params, token) => get(`/v1/Document/Download/${params.id}`, token),
    requestUserDocumentDownload: async (params, token) => get(`/v1/Auction/RequestUserDocumentDownload?ID=${params.id}`, token),
    deleteDocument: async (params, token) => remove(`/v1/Document/Delete?ID=${params.id}`, params, token),
}